/**
 * Publishes Product JSON-LD exactly once after Target Bay reviews are available.
 * Base product data comes from #schema-product-data (application/json, not ld+json).
 */
(function () {
  var DATA_ID = 'schema-product-data';
  var SCRIPT_ID = 'schema-product-jsonld';
  var MAX_REVIEWS = 10;
  var MAX_ATTEMPTS = 150;
  var RETRY_MS = 400;

  var dataEl = document.getElementById(DATA_ID);
  if (!dataEl) return;

  var published = false;
  var observers = [];

  function text(el) {
    return el && (el.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function sanitizeText(value) {
    if (value == null) return '';
    var s = String(value)
      .replace(/\bundefined\b/gi, '')
      .replace(/\bnull\b/gi, '')
      .replace(/\s+/g, ' ')
      .trim();
    if (!s) return '';
    if (/^(undefined|null)+$/i.test(s.replace(/\s/g, ''))) return '';
    return s;
  }

  function scriptHasProduct(data) {
    if (!data || typeof data !== 'object') return false;
    if (data['@type'] === 'Product') return true;
    if (Array.isArray(data['@graph'])) {
      return data['@graph'].some(function (n) {
        return n && n['@type'] === 'Product';
      });
    }
    return false;
  }

  function removeDuplicateSchemas(keepEl) {
    document.querySelectorAll('script[type="application/ld+json"]').forEach(function (s) {
      if (s === keepEl || s.id === SCRIPT_ID) return;
      try {
        if (scriptHasProduct(JSON.parse(s.textContent))) {
          s.parentNode.removeChild(s);
        }
      } catch (e) {
        /* ignore */
      }
    });
  }

  function getGraphRoot(data) {
    if (!data) return null;
    if (Array.isArray(data['@graph'])) return data;
    if (data['@type'] === 'Product') {
      return { '@context': 'https://schema.org', '@graph': [data] };
    }
    return null;
  }

  function getProductNode(root) {
    if (!root || !root['@graph']) return null;
    for (var i = 0; i < root['@graph'].length; i++) {
      if (root['@graph'][i]['@type'] === 'Product') return root['@graph'][i];
    }
    return null;
  }

  function loadBaseGraph() {
    try {
      return getGraphRoot(JSON.parse(dataEl.textContent));
    } catch (e) {
      return null;
    }
  }

  function getFallbackRating() {
    return dataEl.getAttribute('data-fallback-rating') || '';
  }

  function getFallbackReviewCount() {
    return dataEl.getAttribute('data-fallback-review-count') || '';
  }

  function parseRatingFromLabel(el) {
    if (!el) return null;
    var label = el.getAttribute('aria-label') || el.getAttribute('title') || '';
    var match = label.match(/(\d+(\.\d+)?)\s*(out of|\/)\s*(\d+)/i) || label.match(/(\d+(\.\d+)?)/);
    return match ? match[1] : null;
  }

  function parseRatingValue(root) {
    var selectors = [
      '#tbProductReviews .tbProductReview-totalStarRatingIcon',
      '#tbProductReviews .targetbay-reviews-count-star',
      '.product-ratting .targetbay_star_container',
      '.targetbay-reviews-count-star',
      '.targetbay_star_container'
    ];
    for (var i = 0; i < selectors.length; i++) {
      var el = root.querySelector(selectors[i]);
      if (!el) continue;
      var fromLabel = parseRatingFromLabel(el);
      if (fromLabel) return fromLabel;
      var raw = sanitizeText(text(el));
      if (!raw) continue;
      var match = raw.match(/(\d+(\.\d+)?)\s*(out of|\/)\s*\d+/i) || raw.match(/(\d+(\.\d+)?)/);
      if (match) return match[1];
    }
    return null;
  }

  function parseReviewCount(root) {
    var selectors = [
      '#tbProductReviews .targetbay-reviews-count-star',
      '.targetbay-reviews-count-star',
      '.tbProductReview-totalReviews',
      '.targetbay_star_container'
    ];
    for (var i = 0; i < selectors.length; i++) {
      var el = root.querySelector(selectors[i]);
      if (!el) continue;
      var raw = sanitizeText(text(el));
      if (!raw) continue;
      var match =
        raw.match(/(\d[\d,]*)\s*reviews?/i) ||
        raw.match(/\((\d[\d,]*)\)/) ||
        raw.match(/(\d[\d,]*)\s*review/i);
      if (match) return match[1].replace(/,/g, '');
    }
    return null;
  }

  function parseReviewRating(node) {
    var ratingEl = node.querySelector(
      '[data-rating], [data-star-rating], .tb-product-review-rating, .tbProductReview-rating'
    );
    if (!ratingEl) return null;
    var dataRating = ratingEl.getAttribute('data-rating') || ratingEl.getAttribute('data-star-rating');
    if (dataRating && /^\d+(\.\d+)?$/.test(String(dataRating).trim())) {
      return String(dataRating).trim();
    }
    return parseRatingFromLabel(ratingEl);
  }

  function isTopLevelReviewNode(node, reviewRoot) {
    var parent = node.parentElement;
    while (parent && parent !== reviewRoot) {
      if (parent.classList && parent.classList.contains('tbSiteReviews-reviewContainerEach')) {
        return false;
      }
      parent = parent.parentElement;
    }
    return true;
  }

  function parseReviews() {
    var items = [];
    var seen = {};
    var reviewRoot = document.getElementById('tbProductReviews') || document.getElementById('targetbay_reviews');
    if (!reviewRoot) return items;

    var reviewNodes = Array.prototype.slice
      .call(reviewRoot.querySelectorAll('.tbSiteReviews-reviewContainerEach'))
      .filter(function (node) {
        return isTopLevelReviewNode(node, reviewRoot);
      });

    for (var n = 0; n < reviewNodes.length && items.length < MAX_REVIEWS; n++) {
      var node = reviewNodes[n];
      var author = sanitizeText(
        text(
          node.querySelector(
            '.tbProductReview-author, .tbSiteReviews-reviewAuthor, [class*="reviewAuthor"], [class*="author-name"]'
          )
        )
      );
      var body = sanitizeText(
        text(
          node.querySelector(
            '.tbProductReview-content, .tbSiteReviews-reviewContent, [class*="reviewContent"], [class*="review-text"]'
          )
        )
      );

      if (!body || body.length < 3 || /\bundefined\b/i.test(body)) continue;

      var displayName = author && !/undefined/i.test(author) ? author : 'Anonymous';
      var key = displayName + '|' + body.slice(0, 100);
      if (seen[key]) continue;
      seen[key] = true;

      var dateEl = node.querySelector('time[datetime]');
      var date = dateEl
        ? sanitizeText(dateEl.getAttribute('datetime'))
        : sanitizeText(text(node.querySelector('time, [class*="review-date"]')));

      var review = {
        '@type': 'Review',
        author: { '@type': 'Person', name: displayName },
        reviewBody: body
      };
      if (date) review.datePublished = date;
      var ratingValue = parseReviewRating(node);
      if (ratingValue) {
        review.reviewRating = {
          '@type': 'Rating',
          ratingValue: ratingValue,
          bestRating: '5',
          worstRating: '1'
        };
      }
      items.push(review);
    }

    return items;
  }

  function hasReviewWidgetData(pageRoot) {
    return !!(
      parseRatingValue(pageRoot) ||
      parseReviewCount(pageRoot) ||
      parseReviews().length
    );
  }

  function applyReviewsToProduct(product, ratingValue, reviewCount, reviews) {
    delete product.review;

    if (ratingValue || reviewCount) {
      product.aggregateRating = {
        '@type': 'AggregateRating',
        bestRating: '5',
        worstRating: '1'
      };
      if (ratingValue) product.aggregateRating.ratingValue = String(ratingValue);
      if (reviewCount) product.aggregateRating.reviewCount = String(reviewCount);
    }

    if (reviews.length) {
      product.review = reviews.slice(0, MAX_REVIEWS);
    }
  }

  function publishSchema(root) {
    if (published) return;
    published = true;

    removeDuplicateSchemas(null);

    var scriptEl = document.getElementById(SCRIPT_ID);
    if (!scriptEl) {
      scriptEl = document.createElement('script');
      scriptEl.type = 'application/ld+json';
      scriptEl.id = SCRIPT_ID;
      scriptEl.setAttribute('data-schema-role', 'product');
      document.head.appendChild(scriptEl);
    }

    scriptEl.textContent = JSON.stringify(root);
    removeDuplicateSchemas(scriptEl);
    disconnectObservers();
  }

  function disconnectObservers() {
    observers.forEach(function (o) {
      try {
        o.disconnect();
      } catch (e) {
        /* ignore */
      }
    });
    observers = [];
  }

  function tryPublish(forceFallback) {
    if (published) return true;

    var root = loadBaseGraph();
    if (!root) return true;

    var product = getProductNode(root);
    if (!product) return true;

    var pageRoot = document.querySelector('.template-product') || document.body;
    var ratingValue = parseRatingValue(pageRoot);
    var reviewCount = parseReviewCount(pageRoot);
    var reviews = parseReviews();

    if (!ratingValue && !reviewCount && !reviews.length) {
      if (forceFallback) {
        ratingValue = getFallbackRating() || null;
        reviewCount = getFallbackReviewCount() || null;
        if (ratingValue || reviewCount) {
          applyReviewsToProduct(product, ratingValue, reviewCount, []);
          publishSchema(root);
          return true;
        }
        publishSchema(root);
        return true;
      }
      return false;
    }

    if (!reviewCount && reviews.length) {
      reviewCount = String(reviews.length);
    }

    applyReviewsToProduct(product, ratingValue, reviewCount, reviews);
    publishSchema(root);
    return true;
  }

  var attempts = 0;
  function schedule() {
    if (published) return;
    if (tryPublish(false) || attempts >= MAX_ATTEMPTS) {
      if (!published) tryPublish(true);
      return;
    }
    attempts += 1;
    setTimeout(schedule, RETRY_MS);
  }

  function observeReviewWidget() {
    if (typeof MutationObserver === 'undefined') return;

    var observer = new MutationObserver(function () {
      if (published) return;
      var pageRoot = document.querySelector('.template-product') || document.body;
      if (hasReviewWidgetData(pageRoot)) {
        tryPublish(false);
      }
    });

    function watch(el) {
      if (el) observer.observe(el, { childList: true, subtree: true });
    }

    watch(document.getElementById('targetbay_reviews'));
    watch(document.getElementById('tbProductReviews'));
    watch(document.querySelector('.targetbay_star_container'));
    observers.push(observer);
  }

  function observeSchemaInjection() {
    if (typeof MutationObserver === 'undefined') return;

    var observer = new MutationObserver(function () {
      if (!published) return;
      removeDuplicateSchemas(document.getElementById(SCRIPT_ID));
    });

    observer.observe(document.head, { childList: true, subtree: true });
    observer.observe(document.body, { childList: true, subtree: true });
    observers.push(observer);
  }

  removeDuplicateSchemas(null);

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        schedule();
        observeReviewWidget();
      },
      { once: true }
    );
  } else {
    schedule();
    observeReviewWidget();
  }

  window.addEventListener('load', function () {
    if (!published) schedule();
  });

  document.addEventListener('tensnet:targetbay-refresh', function () {
    if (!published) tryPublish(false);
  });

  observeSchemaInjection();
})();
